import { useEffect, useRef, useState } from "react";
import { Card, CardBody, CardHeader, CardTitle, Col, Row } from "reactstrap";
import getIncidents from "../../services/incidentService";
import Incident from "./Incident";

export default function IncidentList({ store }) {
  const [incidents, setIncidents] = useState("");
  const isMounted = useRef(true);

  useEffect(() => {
    fetchIncidents();
    return () => {
      isMounted.current = false;
    };
  }, []);

  async function fetchIncidents() {
    try {
      const incidentData = await getIncidents(store.location);
      if (isMounted.current) setIncidents(incidentData);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  }

  return (
    <div>
      <Card>
        <CardHeader>
          <CardTitle tag="h4">Incidents</CardTitle>
        </CardHeader>
        <CardBody>
          <div>
            <Row>
              <Col md={3}>Type</Col>
              <Col md={2}>Status</Col>
              <Col md={3}>Machine</Col>
              <Col md={3}>Created at</Col>
            </Row>
            {incidents &&
              incidents.map((incident) => (
                <div>
                  <hr
                    style={{
                      borderColor: "light-grey",
                      height: 0.5,
                    }}
                  />
                  <Incident key={incident.id} incident={incident} />
                </div>
              ))}
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
